import { render } from "./LocaleSwitcher.vue?vue&type=template&id=ddd5b282"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script